import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

import '../styles/index.scss';

const App = ({ children }: { children: React.ReactNode }) => {

  const location = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // eslint-disable-next-line
  }, [location]);

  return (
    <React.Fragment>
      <div className="imm_admin__app">
        {children}
        {/* <ToastContainer /> */}
      </div>
    </React.Fragment>
  );
};

export default App;